import { Package } from "lucide-react";
import { cn } from "@/lib/utils";
import { AMAZON_ASIN_URL } from "@/constants/amazon";
import { TruncatedText } from "@/components/ui/truncated-text";

interface ProductCardSmallProps {
  name: string;
  imageUrl?: string;
  asin?: string;
  className?: string;
}

export function ProductCardSmall({ name, imageUrl, asin, className }: ProductCardSmallProps) {
  return (
    <div className={cn("rounded-md border border-border bg-card px-3 py-2 max-w-[420px]", className)}>
      <div className="flex items-center gap-2">
        {imageUrl ? (
          /*
            AUT-279: square thumb, rectangular Amazon source image. object-cover
            centre-cropped it and read as zoomed in / cut off. Letterboxing is
            the accepted trade-off — keep object-contain, do not go back. Reopened:
            the client rejected the grey bars it left, so the thumb is bg-white —
            Amazon source images are white-backed and the bars vanish into the photo.
          */
          <img src={imageUrl} alt={name} className="h-8 w-8 rounded bg-white object-contain shrink-0" />
        ) : (
          <div className="h-8 w-8 rounded bg-muted flex items-center justify-center shrink-0">
            <Package className="h-4 w-4 text-muted-foreground" />
          </div>
        )}
        <div className="min-w-0 flex flex-col">
          <TruncatedText lines={1} className="text-sm font-semibold text-foreground">{name}</TruncatedText>
          {asin && (
            <a
              href={`${AMAZON_ASIN_URL}/${asin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[11px] text-primary hover:underline"
            >
              {asin}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
